import { useNoteById as useSharedNoteById } from '@repo/videa-notes';
import type { UseQueryResult } from '@tanstack/react-query';

import type { ClinicalNote } from './useExistingNotes';

export const useNoteById = (
  clinicalNoteId: string | undefined,
  enabled: boolean,
): UseQueryResult<ClinicalNote | null> =>
  useSharedNoteById(
    clinicalNoteId,
    enabled,
  ) as UseQueryResult<ClinicalNote | null>;
